import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Rate, List, Input, Button } from "antd";
import { useParams } from "react-router-dom";

function Scenario() {
  const { id } = useParams();
  const apiUrl = "https://api.projectrere.org/Scenario/";
  const [users, setUsers] = useState([]);
  const [comments, setComments] = useState([]);
  const [scenario, setScenario] = useState({});
  const [message, setMessage] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(apiUrl + "Get/?Id=" + id);
      setScenario(response.data);
      setUsers(response.data.users);
    };
    fetchData();
  }, []);

  const fetchComments = async () => {
    const response = await axios.get(
      apiUrl + "GetScenarioComents" + "?ScenarioId=" + id
    );
    setComments(response.data);
  };

  useEffect(() => {
    fetchComments();
  }, []);

  const getFullDate = (date) => {
    const dateAndTime = date.split("T");
    return dateAndTime[0].split("-").reverse().join("-");
  };

  const handleChange = (e) => {
    setMessage(e.currentTarget.value);
  };

  const handleClick = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    axios
      .post(apiUrl + "AddScenarioComents", {
        fromUserId: user.id,
        fromUserName: user.username,
        scenarioId: id,
        message: message,
      })
      .then(function (response) {
        fetchComments();
        setComments("");
      })
      .catch(function (error) {});
  };
  const colsComment = [
    {
      title: "Date",
      width: 20,
      dataIndex: "createdDate",
      className: "text-xs",
      defaultSortOrder: "ascend",
      // specify the condition of filtering result
      // here is that finding the name started with `value`
      sorter: (a, b) => a.createdDate - b.createdDate,
      sortDirections: ["ascend", "descend"],
      render: (date) => getFullDate(date),
    },
    {
      title: "From",
      width: 20,
      dataIndex: "fromUserName",
      defaultSortOrder: "ascend",
      className: "capitalize",
      sorter: (a, b) => a.fromUserName > b.fromUserName,
    },
    {
      title: "Comment",
      dataIndex: "message",
      defaultSortOrder: "ascend",
      className: "capitalize",
      sorter: (a, b) => a.message > b.message,
    },
  ];

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      className: "text-xs",
      defaultSortOrder: "ascend",
      // specify the condition of filtering result
      // here is that finding the name started with `value`
      sorter: (a, b) => a.id - b.id,
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Name",
      dataIndex: "title",
      defaultSortOrder: "ascend",
      className: "capitalize",
      render: (text, record) => {
        return text == "" ? "Noname" : text;
      },
      sorter: (a, b) => a.name > b.name,
    },
    {
      title: "Score",
      dataIndex: "score",
      defaultSortOrder: "descend",
      render: (_, { avarageScore, scoreNumber }) => (
        <>
          <Rate disabled count={3} defaultValue={avarageScore} />
          <div>Score:{scoreNumber.toFixed(0)}</div>
        </>
      ),
      sorter: (a, b) => a.score - b.score,
    },
  ];
  const onChange = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra);
  };
  return (
    <main className="scenario-single">
      <header>
        <h1>{scenario.title}</h1>
      </header>
      <div className="container">
        <section>
          <div className="wrapper">
            <header>
              <h2>Document</h2>
            </header>
            <iframe
              key={scenario.docLink}
              src={scenario.docLink}
              className="iframe"
              title="document"
            ></iframe>
          </div>
          <div className="wrapper">
            <header>
              <h2>Video</h2>
            </header>
            <iframe
              key={scenario.videoLink}
              src={scenario.videoLink}
              className="iframe"
              title="video"
            ></iframe>
          </div>
        </section>
        <section>
          <div className="wrapper">
            <header>
              <h2>Users</h2>
            </header>
            <Table
              columns={columns}
              dataSource={users.slice(5)}
              rowKey={"id"}
              rowClassName="table-row"
              onChange={onChange}
              pagination={{ pageSize: 5 }}
              showSorterTooltip={{
                target: "sorter-icon",
              }}
            />
          </div>
          <div className="wrapper">
            <header>
              <h2>Comments</h2>
            </header>
            {/* <List
              size="small"
              header={
                <div className="input-group">
                  <Input placeholder="comment..." onChange={handleChange} />
                  <Button type="primary" onClick={handleClick}>
                    Send
                  </Button>
                </div>
              }
              footer={<div>Footer</div>}
              bordered
              dataSource={comments}
              renderItem={(item) => <List.Item>{item.message}</List.Item>}
            /> */}
            <div className="input-group">
              <Input placeholder="comment..." onChange={handleChange} />
              <Button type="primary" onClick={handleClick}>
                Send
              </Button>
            </div>
            <Table columns={colsComment} dataSource={comments} />
          </div>
        </section>
      </div>
    </main>
  );
}

export default Scenario;
